module.exports = __webpack_public_path__ + "img/img_tutorial_02.6f13b8b0.svg";